"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = require("prop-types");

var _react = _interopRequireDefault(require("react"));

var _hyperlink = _interopRequireDefault(require("@ingka/hyperlink"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Breadcrumb = _ref => {
  let {
    prefix,
    children,
    items,
    id,
    ...otherProps
  } = _ref;

  function generateListItem(content, i) {
    return _react.default.createElement("li", {
      key: id ? `${id}-${i}` : i,
      itemScope: true,
      itemProp: "itemListElement",
      itemType: "http://schema.org/ListItem",
      className: (0, _classnames.default)(`${prefix}breadcrumb__list-item`)
    }, ' ', content, ' ', _react.default.createElement("meta", {
      itemProp: "position",
      content: i + 1
    }));
  }

  function generateChild(child) {
    return _react.default.cloneElement(child, {
      itemProp: 'item',
      colour: 'black',
      className: child.props.className ? child.props.className + ` ${prefix}breadcrumb__link` : `${prefix}breadcrumb__link`
    });
  }

  function generateLink(item) {
    return _react.default.createElement(_hyperlink.default, {
      itemProp: "item",
      colour: "black",
      className: `${prefix}breadcrumb__link`,
      url: item.url
    }, _react.default.createElement("span", {
      itemProp: "name"
    }, item.text));
  }

  const navClasses = (0, _classnames.default)(`${prefix}breadcrumb__nav`);
  let listItems;

  if (children) {
    listItems = _react.default.Children.map(children, (child, i) => {
      const link = generateChild(child);
      return generateListItem(link, i);
    });
  } else if (items) {
    listItems = items.map((item, i) => {
      const link = generateLink(item);
      return generateListItem(link, i);
    });
  }

  return _react.default.createElement("div", {
    className: `${prefix}breadcrumb`
  }, _react.default.createElement("nav", _extends({
    role: "navigation"
  }, otherProps, {
    id: id,
    "aria-label": "Breadcrumb",
    className: navClasses
  }), _react.default.createElement("ol", {
    itemScope: true,
    itemType: "http://schema.org/BreadcrumbList",
    itemProp: "breadcrumb",
    className: `${prefix}breadcrumb__list`
  }, listItems)));
};

Breadcrumb.defaultProps = {
  prefix: ''
};
var _default = Breadcrumb;
exports.default = _default;